import type { CSSProperties, ReactNode } from 'react'

export type ChipTone = 'default' | 'success' | 'danger' | 'warning' | 'accent'

export interface ChipProps {
  tone?: ChipTone
  children: ReactNode
}

const toneMap: Record<ChipTone, { bg: string; fg: string }> = {
  default: { bg: 'var(--color-surface-2)', fg: 'var(--color-text-muted)' },
  success: { bg: 'var(--color-success-soft)', fg: 'var(--color-success-text)' },
  danger:  { bg: 'var(--color-danger-soft)',  fg: 'var(--color-danger-text)' },
  warning: { bg: 'var(--color-warning-soft)', fg: 'var(--color-warning-text)' },
  accent:  { bg: 'var(--color-primary-soft)', fg: 'var(--color-primary-text)' },
}

export function Chip({ tone = 'default', children }: ChipProps) {
  const colors = toneMap[tone]
  const style: CSSProperties = {
    display: 'inline-block',
    background: colors.bg,
    color: colors.fg,
    fontSize: 'var(--font-size-xs)',
    fontWeight: 600,
    padding: '2px 6px',
    borderRadius: 'var(--radius-sm)',
    letterSpacing: '0.3px',
  }
  return <span style={style}>{children}</span>
}
